export const asyncFilter = (array, filter) => Promise.all(array.map((entry, index) => filter(entry, index).catch(() => false))).then(bits => array.filter(() => bits.shift()));
export const awaitToRequest = (request) => request.then(data => [null, data]).catch(err => [err, undefined]);
export const asyncForEach = async (array, callback) => {
    for (let i = 0; i < array.length; i += 1) {
        await callback(array[i], i, array);
    }
};
export const asyncMap = async (array, callback) => Promise.all(array.map(callback));
export const findAsyncSequential = async (array, predicate) => {
    for (const item of array) {
        if (await predicate(item)) {
            return item;
        }
    }
    return undefined;
};
export const findAsyncParallel = async (array, predicate) => {
    const promises = array.map(predicate);
    const results = await Promise.all(promises);
    const index = results.findIndex(result => result);
    return array[index];
};
//# sourceMappingURL=async-helpers.js.map